import { render, staticRenderFns } from "./commentlist.vue?vue&type=template&id=21d74da3&scoped=true"
import script from "./commentlist.vue?vue&type=script&lang=js"
export * from "./commentlist.vue?vue&type=script&lang=js"
import style0 from "./commentlist.vue?vue&type=style&index=0&id=21d74da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d74da3",
  null
  
)

export default component.exports